"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var functions_exports = {};
__export(functions_exports, {
  canCancelInvitation: () => canCancelInvitation,
  canCancelInvitationCode: () => canCancelInvitationCode,
  canResendInvitation: () => canResendInvitation,
  invitationCodeRequiresApproval: () => invitationCodeRequiresApproval,
  invitationCodeStatus: () => invitationCodeStatus,
  invitationStatus: () => invitationStatus
});
module.exports = __toCommonJS(functions_exports);
var import_date_fns = require("date-fns");
var import_core = require("../core/index.js");
function invitationStatus(invitation, timestamp = (0, import_core.nowTimestamp)()) {
  if (invitation.accepted != null) {
    return "Accepted";
  } else if (invitation.canceled != null) {
    return "Canceled";
  } else if (invitation.expires != null && (0, import_date_fns.isBefore)((0, import_core.timestampToDate)(invitation.expires), (0, import_core.timestampToDate)(timestamp))) {
    return "Expired";
  } else {
    return "Pending";
  }
}
function invitationCodeStatus(invitation, timestamp = (0, import_core.nowTimestamp)()) {
  if (invitation.canceled != null) {
    return "Canceled";
  } else if (invitation.expires != null && (0, import_date_fns.isBefore)((0, import_core.timestampToDate)(invitation.expires), (0, import_core.timestampToDate)(timestamp))) {
    return "Expired";
  } else {
    return "Pending";
  }
}
function canCancelInvitation(invitation) {
  return invitation.accepted == null && invitation.canceled == null && (invitation.expires == null || (0, import_core.timestampEpoch)(invitation.expires) >= (0, import_core.timestampEpoch)((0, import_core.nowTimestamp)()));
}
function canCancelInvitationCode(invitation) {
  return invitation.canceled == null && (invitation.expires == null || (0, import_core.timestampEpoch)(invitation.expires) >= (0, import_core.timestampEpoch)((0, import_core.nowTimestamp)()));
}
function canResendInvitation(invitation) {
  return invitation.accepted == null;
}
function invitationCodeRequiresApproval(code, email) {
  const domain = (0, import_core.emailDomain)(email);
  if (domain == null || code.approvalDomainAllowList == null) {
    return code.requireApproval;
  } else {
    return code.requireApproval && !code.approvalDomainAllowList.includes(domain);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  canCancelInvitation,
  canCancelInvitationCode,
  canResendInvitation,
  invitationCodeRequiresApproval,
  invitationCodeStatus,
  invitationStatus
});
//# sourceMappingURL=functions.js.map
